import amplitude from "amplitude-js";
import { AMPLITUDE_KEY, PALTA_DATA_PLATFORM_KEY } from "@/constants/env";
import { Tracker } from "./common";

type EventProps = {
    [key: string]: string | string[] | number | null | boolean | undefined | Date;
};

const PALTA_DATA_PLATFORM_INSTANCE_NAME = "palta_data_platform";
const PALTA_API = "telemetry.zing.paltabrain.com/v1/amplitude";

class AmplitudeInstance extends Tracker {
    private readonly _name: string | undefined = undefined;
    private readonly _key: string | undefined = undefined;
    private readonly _apiEndpoint: string | undefined = undefined;

    private _propertiesQueue: EventProps = {};
    private _eventsQueue: { event: string; eventProps?: EventProps }[] = [];

    constructor(key: string, name?: string, apiEndpoint?: string) {
        super();

        this._key = key;
        this._name = name;
        this._apiEndpoint = apiEndpoint;
    }

    init() {
        if (this._key && !this._isInitialized) {
            amplitude.getInstance(this._name).init(
                this._key,
                undefined,
                this._apiEndpoint
                    ? {
                          apiEndpoint: this._apiEndpoint,
                      }
                    : undefined
            );
            this._isInitialized = true;
            this.proceedPropertiesQueue();
            this.proceedEventsQueue();
        }

        if (this._isStoped) {
            this._isStoped = false;
        }
    }

    setAmplitudeProperties(props: EventProps) {
        const instance = amplitude.getInstance(this._name);
        if (this._isInitialized && !this._isStoped) {
            instance.setUserProperties(props);
        } else {
            this._propertiesQueue = {
                ...this._propertiesQueue,
                ...props,
            };
        }
    }

    track(event: string, eventProps?: EventProps) {
        const instance = amplitude.getInstance(this._name);
        if (this._isInitialized && !this._isStoped) {
            instance.logEvent(event, eventProps);
        } else {
            this._eventsQueue.push({ event, eventProps });
        }
    }

    setUserId(uuid: string) {
        amplitude.getInstance(this._name).setUserId(uuid);
    }

    private proceedPropertiesQueue() {
        this.setAmplitudeProperties(this._propertiesQueue);
    }

    private proceedEventsQueue() {
        this._eventsQueue.forEach(({ event, eventProps }) => this.track(event, eventProps));
    }
}

export const PaltaDataPlatformTracker = new AmplitudeInstance(
    PALTA_DATA_PLATFORM_KEY,
    PALTA_DATA_PLATFORM_INSTANCE_NAME,
    PALTA_API
);
export const AmplitudeTracker = new AmplitudeInstance(AMPLITUDE_KEY);
